// extracted by mini-css-extract-plugin
module.exports = {"trademark":"trademark-mod__trademark___2FD9r","sogodyLogo":"trademark-mod__sogodyLogo___1U80O","fading":"trademark-mod__fading___h17Y_"};